import { Button } from 'framework/ui/mui-builder';
import { useShowContext } from 'framework/show';
import { Typography } from '@mui/material';
import React from 'react';
import {
  ACCESS_INFO_ACTIONS,
  ACCESS_INFO_SECTIONS,
  OUTCOME_STATUS,
  useProjectSecurityContext,
} from 'domain/shared/newProject';
import { useListContext } from 'framework/list';
import useOutcomesService from './useOutcomesService';

const BusinessOutcomesCompleteButton = () => {
  const { data } = useShowContext();
  const { completeBusinessOutcome } = useOutcomesService();
  const { isAccessGranted } = useProjectSecurityContext();
  const { updateInList } = useListContext();

  return (
    <>
      {data.status === OUTCOME_STATUS.ACTIVE ? (
        isAccessGranted(ACCESS_INFO_SECTIONS.BUSINESS_OUTCOME, ACCESS_INFO_ACTIONS.MANAGE) ? (
          <Button
            variant="contained"
            onClick={async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
              e.stopPropagation();
              const result = await completeBusinessOutcome(data.id, {});
              // Row is updated in place from the response; no refetch (which blanked the whole tab).
              updateInList?.(result);
            }}
          >
            Complete
          </Button>
        ) : null
      ) : (
        <Typography color="success">Completed</Typography>
      )}
    </>
  );
};
export default BusinessOutcomesCompleteButton;
